/* Product-page color clicks reveal the chosen media without changing inventory rules. */
(() => {
  let cancelPending = () => {};
  function reveal(picker, value, index) {
    const product = picker.closest('.main-product');
    const slideshow = product?.querySelector('sht-prd-slideshow');
    if (!slideshow) return;
    let variants;
    try { variants = JSON.parse(picker.querySelector('script[type="application/json"]').textContent); } catch (_) { return; }
    const variant = picker.currentVariant?.options?.[index] === value ? picker.currentVariant : variants.find(v => v.options?.[index] === value);
    const mediaId = variant?.featured_media?.id;
    if (!mediaId) return;
    cancelPending();
    let timer, stopTimer, done = false;
    const observer = new MutationObserver((records) => {
      if (!records.some(record => [...record.addedNodes].some(node => node.nodeType === 1 && (node.matches('sht-carousel-wrapper,sht-carousel') || node.querySelector('.product-slideshow__items'))))) return;
      if (!slideshow.querySelector(`.product-slideshow__item--image[data-media-id$="-${mediaId}"]`)) return;
      done = false;
      finish();
    });
    const scroll = () => {
      const tile = slideshow.querySelector(`.product-slideshow__item--image[data-media-id$="-${mediaId}"]`);
      if (!tile) return;
      const track = tile.closest('.js-carousel-items');
      if (track) {
        const items = [...track.children];
        const start = items.indexOf(tile);
        if (start > 0) {
          const ordered = items.slice(start).concat(items.slice(0,start));
          const videoIndex = ordered.findIndex(item => item.classList.contains('product-slideshow__item--video'));
          if (videoIndex >= 0) {
            const video = ordered.splice(videoIndex,1)[0];
            ordered.splice(Math.min(2,ordered.length),0,video);
          }
          ordered.forEach(item => track.appendChild(item));
        }
        track.querySelectorAll('.mirage-product-swatch-preview').forEach(image => image.classList.remove('is-active'));
        track.scrollTo({left:0,behavior:'auto'});
      }
      let offset = 16;
      document.querySelectorAll('.mgh-header,.site-header').forEach(header => {
        if (['fixed','sticky'].includes(getComputedStyle(header).position)) offset = Math.max(offset,header.getBoundingClientRect().bottom + 16);
      });
      window.scrollTo({top:Math.max(0,window.scrollY+slideshow.getBoundingClientRect().top-offset),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});
    };
    const finish = () => { if(done)return;done=true;clearTimeout(timer);requestAnimationFrame(scroll); };
    observer.observe(slideshow,{childList:true,subtree:true});
    // Wait briefly for the theme's reordered gallery; still reveal media if its request fails.
    timer = setTimeout(finish,450);
    stopTimer = setTimeout(() => observer.disconnect(),2500);
    cancelPending = () => {done=true;clearTimeout(timer);clearTimeout(stopTimer);observer.disconnect();};
  }
  document.addEventListener('click',event => {
    const swatch = event.target.closest('.template-product .main-product .product-swatches__item');
    const picker = swatch?.closest('sht-variant-radios,sht-variant-selects');
    const input = swatch?.querySelector('input[type="radio"]');
    if (!picker || !input) return;
    const groups = [...picker.querySelectorAll('.js-variant-radio-container')];
    const index = groups.indexOf(input.closest('.js-variant-radio-container'));
    if (index < 0) return;
    setTimeout(() => reveal(picker,input.value,index),0);
  });
})();

// Finish every two-column gallery row without deleting a color or duplicating media.
(() => {
  let frame;
  function balance() {
    document.querySelectorAll('.main-product sht-prd-slideshow .product-slideshow__items').forEach(track => {
      const wide = new Set();
      let pending = null;
      for (const tile of track.children) {
        if (!tile.classList.contains('product-slideshow__item')) continue;
        const fullVideo = tile.classList.contains('product-slideshow__item--video') &&
          !(tile.closest('.mirage-product--backpack') && tile.classList.contains('mirage-product-video--portrait'));
        if (fullVideo) {
          if (pending) wide.add(pending);
          pending = null;
        } else {
          pending = pending ? null : tile;
        }
      }
      if (pending) wide.add(pending);
      for (const tile of track.children) tile.classList.toggle('mirage-gallery-row-end', wide.has(tile));
    });
  }
  function schedule() { cancelAnimationFrame(frame); frame = requestAnimationFrame(balance); }
  const root = document.querySelector('.main-product');
  if (!root) return;
  new MutationObserver(schedule).observe(root, {childList:true, subtree:true});
  root.addEventListener('loadedmetadata', schedule, true);
  document.addEventListener('shopify:section:load', schedule);
  schedule();
})();
